import { render, staticRenderFns } from "./helpProject.vue?vue&type=template&id=9c89ea26&scoped=true&"
import script from "./helpProject.vue?vue&type=script&lang=js&"
export * from "./helpProject.vue?vue&type=script&lang=js&"
import style0 from "./helpProject.vue?vue&type=style&index=0&id=9c89ea26&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c89ea26",
  null
  
)

export default component.exports